import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moneyComma',
  standalone: true,
})
export class MoneyCommaPipe implements PipeTransform {
  transform(value: number | string | null | undefined, currencyCode = 'EUR'): string {
    const numericValue = Number(value ?? 0);
    if (!Number.isFinite(numericValue)) {
      return `${currencyCode} 0.00`;
    }

    const formatted = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue);

    return `${currencyCode} ${formatted}`;
  }
}
